import { cn } from '../lib';
import * as React from 'react';
import { useRTL } from '../hooks';
import { selectIsMinimalistic, useAppSelector } from '@/app/store';

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  const isRTL = useRTL();
  const isMinimalistic = useAppSelector(selectIsMinimalistic);

  return (
    <textarea
      data-slot='textarea'
      className={cn(
        'border border-solid border-input shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex field-sizing-content min-h-16 w-full rounded-md bg-transparent px-3 py-2 text-sm leading-[20px] transition-[color,box-shadow] outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        isRTL && 'text-right placeholder:text-right',
        isMinimalistic && 'rounded-none shadow-none',
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
